import { Review } from "@/types/reviewType";
import { Axios, CursorPaginationResult } from "goi_common";

interface getSangjoReviewsParams {
  is_best_review?: boolean;
}

export const getSangjoReviews = async (params?: getSangjoReviewsParams) => {
  const { data } = await Axios.get<CursorPaginationResult<Review>>("/sangjo_reviews/", {
    params,
  });

  return data;
};
